<div fxLayoutAlign="space-between" class="strong-password-advice-container">
  <div fxLayout="column">
    <div
      class="password-help-item"
      [class.active]="hasUppercaseLetters"
      [ngClass]="color"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px">
      <app-icon name="check_circle_filled" size="22"></app-icon>
      <div class="description">Jedna wielka litera</div>
    </div>

    <div
      class="password-help-item"
      [class.active]="hasEightChars"
      [ngClass]="color"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px">
      <app-icon name="check_circle_filled" size="22"></app-icon>
      <div class="description">Minimum osiem znaków</div>
    </div>
  </div>

  <div fxLayout="column">
    <div
      class="password-help-item"
      [ngClass]="color"
      [class.active]="hasLowercaseLetters"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px">
      <app-icon name="check_circle_filled" size="22"></app-icon>
      <div class="description">Jedna mała litera</div>
    </div>

    <div
      class="password-help-item"
      [class.active]="hasDigits"
      [ngClass]="color"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px">
      <app-icon name="check_circle_filled" size="22"></app-icon>
      <div class="description">Jedna cyfra</div>
    </div>
  </div>
</div>
